import React, { useMemo, useState } from 'react';
import { Form } from 'components/atoms';
import { Formik, Field } from 'formik';
import { FieldCustom } from 'components/molecules';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useDebounce } from 'react-use'
import { getDefault } from './utils'

const defaultSchema = getDefault()

const FactsSchema = Yup.object().shape({
  title: Yup.string()
    .min(2, 'Mínimo de 2 caracteres')
    .max(120, 'Máximo de 120 caracteres')
    .required('Campo Obrigatório'),
  text: Yup.string().notRequired().nullable(),
  source: Yup.string().notRequired().nullable(),
});

const FactsEditor = ({ initialProps, onChange }) => {
  const [editorProps, setEditorProps] = useState(initialProps)

  const initialValues = useMemo(() => {
    const { title, text, source } = initialProps;
    return {
      title: title === defaultSchema.title ? '' : title,
      text,
      source
    };
  }, [initialProps]);

  const handleFormChange = newValues => {
    const newProps = { ...initialProps, ...newValues };
    const isValid = FactsSchema.isValidSync(newProps)
    if (isValid) setEditorProps(newProps)
  };

  useDebounce(() => {
    onChange(editorProps);
  }, 200,
  [editorProps]
  )

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={FactsSchema}
      validate={handleFormChange}
    >
      <Form>
        <Field
          title="Texto"
          name="title"
          info="Uma frase, uma citação,..."
          component={FieldCustom}
          maxLetters={120}
        />
        <Field
          title="Fonte ou autor"
          name="source"
          info="Fonte ou autor do texto"
          component={FieldCustom}
        />
        <Field
          title="Data"
          name="text"
          info="Identificação cronológica da frase ou citação"
          component={FieldCustom}
        />
      </Form>
    </Formik>
  );
};
FactsEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialProps: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    source: PropTypes.string,
  }),
};

FactsEditor.defaultProps = {
  initialProps: {},
};

export default FactsEditor;
